import { createContext, useState } from "react";

export const SysCategoryContext = createContext({});

export const Provider = (props) => {
    const { children } = props;

    const [sysCategories, setSysCategories] = useState([]);

    // Make the context object:
    const sysCategoryContext = {
        sysCategories,
        setSysCategories,
    };

    // pass the value in provider and return
    return <SysCategoryContext.Provider value={sysCategoryContext}>{children}</SysCategoryContext.Provider>;
};

export const { Consumer } = SysCategoryContext;
